function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
import { Tag } from '@dtsl/react/dist/components/Tag';
import { Text } from '@dtsl/react/dist/components/Text';
const Content = _ref => {
  let {
    label = '',
    tagMetaData,
    icon,
    helpText,
    isGroup = false
  } = _ref;
  const leftContentContainerClass = classNames({
    [treeStyles['sib-tree-view__exp-item-desc-left']]: true,
    [treeStyles['sib-tree-view__exp-item-desc-left--no-icon']]: !icon
  });
  const helpTextClass = classNames({
    [treeStyles['sib-tree-view__exp-item-help-txt']]: true,
    [treeStyles['sib-tree-view__exp-item-help-txt--no-icon']]: !icon
  });
  return /*#__PURE__*/React.createElement("div", {
    className: treeStyles['sib-tree-view__exp-item-desc']
  }, /*#__PURE__*/React.createElement("div", {
    className: leftContentContainerClass
  }, typeof icon === 'function' && icon(), /*#__PURE__*/React.createElement(Text, {
    fontFamily: isGroup ? 'interactive' : 'regular',
    size: "lg",
    color: "var(--sib-color_content-primary)"
  }, label), helpText && /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    color: "var(--sib-color_content-secondary)",
    className: helpTextClass
  }, helpText)), tagMetaData && /*#__PURE__*/React.createElement(Tag, _extends({}, tagMetaData, {
    border: true,
    styles: {
      background: 'var(--sib-color_information-background-dark, hsla(244, 65.2%, 91%, 1))'
    }
  })));
};
Content.propTypes = {
  label: PropTypes.string,
  tagMetaData: PropTypes.object,
  icon: PropTypes.func,
  helpText: PropTypes.string,
  isGroup: PropTypes.bool
};
export default Content;